simply.clickEvent = function(){

  $(".product_bottom .click_btn").click(function(){
    var popup = $(this).closest(".product_main").find("#product_popup");
    $.fancybox(popup,{
      helpers : {  
        overlay : {closeClick: false,locked: true}
      }
      }); 
    });

  $(".collection-product-list .new_collection_page .product_description .jar_popup").click(function(){
    var coffeejar_popup=$(this).closest(".product_item").find(".coffeejar_popup");
    $.fancybox(coffeejar_popup,{
      helpers : {  
        overlay : {closeClick: false,locked: true}
      } 
      }); 
    });

  $('.coffee_packages_section .popup_coffee_packages').click(function() {
    var popup_parent = $(this).parent();
    var data_model = $('.popup_coffee_packages_container_wrap',popup_parent);
    $.fancybox.open(data_model);
  });

  $(".collection-product-list .new_collection_page .product_description .mug_popup").click(function(){
    var coffeemug_popup=$(this).closest(".product_item").find(".coffeemug_popup");
    $.fancybox(coffeemug_popup,{
      helpers : {  
        overlay : {closeClick: false,locked: true}
      }
      }); 
    });

  $(".what_tayst .wrapper .see_more_section .see_more_btn").click(function(event) {
    $('html, body').animate({
      scrollTop: $( ".getting_section").offset().top 
      }, 1500); 
  });
  // introductory box detail popup event
  $(".pop_detail").click(function(){
    var coffee_type = $(this).closest(".data_item").attr("data-value");
    coffee_type = coffee_type.toLowerCase().split(' ').join('-');
    var detail_pop_par = $("#detail_popup_wrap");
    var pop_content = $(".popup_content[brew-style="+coffee_type+"]",detail_pop_par);
    if(!cn($(".detail_content_data",pop_content).html())){
      $.fancybox.open(pop_content);
    }
  });
  //  bottom footer product faqs
  $(document).on("click",".product-faq-blocks .product-faqs .faq-question",function(e){
    e.stopPropagation();
    var parent = $(this).closest(".product-faqs");
    var curr_ans = $(this).parent().find(".faq-answer");
    $(".faq-question",parent).not(this).removeClass("active");
    $(".faq-answer",parent).not(curr_ans).stop().slideUp();
    $(this).toggleClass("active");
    $(this).next(".faq-answer").stop().slideToggle();
  });

  //  blog navigation mobile toggle
  $(".marketing-nav__secondary__button").click(function(e){
    var target_ul = $(this).attr("aria-controls");
    $(this).closest(".nav-wrapper").find("#"+target_ul).stop().slideToggle();
  });
};

simply.miniHeightAction =  function(selector){
  var min_height=0;
  $(selector).each(function(){
    var height=$(this).outerHeight();
    if(height>min_height){
      min_height=height;
    }
    });
  return min_height;
};
simply.miniHeight = function(parent,select){
  if($(parent).length > 0){
    var result=simply.miniHeightAction(select);
    $(parent).css("height",result);
  }
};

simply.queryString = function(){
 var vars = {};
 var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
 for(var i = 0; i < hashes.length; i++)
 {
   var hash = hashes[i].split('=');
   var obj = {};
   obj.name = decodeURI(hash[0]);
   obj.value = decodeURI(hash[1]);
   vars[obj.name] = obj;
 }
 return vars;
};

simply.officeCoffeePromoBanner =  function(){
  var promo_found = false;
  var params = simply.queryString();
  $('.home_top_banner_office_coffee .promo_content').addClass('hide');
  if(!cn(params.refcode) ){
    if($('.home_top_banner_office_coffee .promo_content[data-promo="'+params.refcode.value+'"]').length > 0){
      $('.home_top_banner_office_coffee .promo_content[data-promo="'+params.refcode.value+'"]').removeClass('hide');
      $('.home_top_banner_office_coffee .img').addClass('promo_hide');
    }
    else{
     $('.home_top_banner_office_coffee .img').removeClass('hide'); 
   }
   $('.delicious_top_banner').hide();

   }else{
     $('.home_top_banner_office_coffee .img').removeClass('hide'); 
   }
 };  
 simply.headerTool =  function(){
  var promo_found = false;
  var promo = simply.queryString();
  var header_par = $(".theme-body");
  if(!cn(promo.header)){
    var promo_data = $('.global-header-tool-block .header-promo-code[data-promo="'+promo.header.value+'"]',header_par);
    if(promo_data.length > 0){
      promo_data.removeClass('tw-hidden');
    }
    else{
      $('.page-main-banner-section .page-main-banner-bg-img',header_par).removeClass('tw-hidden'); 
    }  
  }
  else{
    $(' .page-main-banner-section .page-main-banner-bg-img',header_par).removeClass('tw-hidden'); 
  }
};  
simply.officeCoffeePopBanner =  function(){
  if($(".compostable-office-coffee").length > 0 || $(".delicious-office-coffee").length > 0){
    var promo_found = false;
    var promo = simply.queryString();
    if(!cn(promo.pop)){
      if($('.delicious_office_content[data-promo="'+promo.pop.value+'"]').length > 0){
        $('.delicious_office_content[data-promo="'+promo.pop.value+'"]').removeClass('hide');
      }  
    }
  }
}; 
simply.getUrlVars = function(){
  var vars = [], hash;
  var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
  for(var i = 0; i < hashes.length; i++){
    hash = hashes[i].split('=');
    vars.push(hash[0]);
    vars[hash[0]] = hash[1];
  }
  return vars;
};
simply.checkHeaderParam = function(){
  var header_query = simply.getUrlVars();
  if(header_query.header != undefined){
    $("#our_coffee .our_coffee_promotion .green_btn_block").each(function(){
      var btn_href = $(this).find(".greenbtn").attr("href");
      $(this).find(".greenbtn").attr("href",btn_href+"?header="+header_query.header);
    });
  }
};

simply.loadJsAsync = function(){
  var dashboard = $(".template-name-myaccount");
  if(simply.asyncurls){
    for (var i = 0; i < simply.asyncurls.length; i++) {
      var url  = simply.asyncurls[i];
      var s = document.createElement('script');
      s.type = 'text/javascript';
      s.async = true;
      s.src = simply.asyncurls[i];
      var x = document.getElementsByTagName('script')[0];
      var addScript = true;
      // if(url.includes('d10lpsik1i8c69') && dashboard.length == 0){
      //   addScript = false;
      // }
      if(addScript){
        x.parentNode.insertBefore(s, x);
      }
    }  
  }
};
simply.imageLoadOnScroll = function(){
  $(".lazyloadscroll").each(function(index, el) {
    if($(el).closest('.slick-slide').length != 0 || $(el).closest(".owl-carousel").length != 0 ){
      el = $(el).closest('.shopify-section');
      el = el[0];
    }
    if(simply.elementInViewport(el)){
      $(el).addClass('lazyload').removeClass('lazyloadscroll');
      $(".lazyloadscroll",$(el)).addClass('lazyload').removeClass('lazyloadscroll');
    } 
  });
};
simply.headerFunction = function(){
  $(document).on("click",".site-header-wrap .mobile-nav-toggle",function(e){
    $(this).toggleClass("active");
    var nav_parent = $(this).closest(".header-content");
    $(".nav-mob .site-header-navigation",nav_parent).stop().slideToggle("fast");
    $("body,html").toggleClass("menu-open");

  });
  $(document).on("click",".header-links-wrap .nav-link.has-menu .nav-link-item",function(){
    var sub_parent = $(this).closest(".nav-link.has-menu");
    if(screen.width < 1025){
      $(this).toggleClass("active");
      $(".child-nav-content",sub_parent).stop().slideToggle();
    }
  });
  $( ".nav-link.has-menu" ).hover(function() {
    if(screen.width > 1024){
      $(this).find(".child-nav-content").stop().slideDown("fast");
    }
  }, function() {
    if(screen.width > 1024){
      $(this).find(".child-nav-content").stop().slideUp("fast");
    }
  });
};

simply.elementInViewport = function (el) {
  var top = el.offsetTop;
  var left = el.offsetLeft;
  var width = el.offsetWidth;
  var height = el.offsetHeight;
  // top = top - 50;
  while(el.offsetParent) {
    el = el.offsetParent; 
    top += el.offsetTop;
    left += el.offsetLeft;
  }

  return (
    top < (window.pageYOffset + window.innerHeight) &&
    left < (window.pageXOffset + window.innerWidth) &&
    (top + height) > window.pageYOffset &&
    (left + width) > window.pageXOffset
    );
};

simply.slickSlider = function(){
  if($("#product_page .secondary_img .bxslider .secondary-img-wrapper").length > 0){
    $('#product_page .secondary_img .bxslider').slick({
      dots: false,
      slidesToShow: 3,
      slidesToScroll: 3,
      arrows:false,
      responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        }
      },
      {
        breakpoint: 360,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      }
      ]
    });
  }
  if($(".owl-carousel-slick").length > 0){
    $('.owl-carousel-slick').slick({
      dots: false,
      slidesToShow: 4,
      slidesToScroll: 4,
      arrows:true,
      responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 360,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
      ]
    });
  }
};

simply.init = function(){
  if (navigator.userAgent.match(/Mac OS X/)){$('body').addClass('x-mac');}
  $("body").removeClass("body-hide");
  simply.clickEvent();
  simply.officeCoffeePromoBanner(); 
  simply.officeCoffeePopBanner(); 
  simply.headerTool();
  simply.slickSlider();
  simply.headerFunction();
  $(window).on('scroll', function(){
    simply.imageLoadOnScroll();
  });
  $(window).on('load', function(){
    simply.loadJsAsync();
    simply.imageLoadOnScroll("ready");
  });
  if($("#our_coffee .our_coffee_promotion.pass_header").length > 0){
    simply.checkHeaderParam();
  }
};
simply.collectionProdHeight = function() {
  var collection_title_par = ".collection-block .collection_div";
  if(collection_title_par.length > 0){
    $(collection_title_par).each(function(index,e){
      item_title = $(".grid__item .product_title",$(e));
      item_title_child = $(".grid__item .product_title span",$(e));
      item_desc = $(".grid__item .product_description",$(e));
      item_desc_child = $(".grid__item .product_description div",$(e));
      simply.miniHeight(item_title,item_title_child);
      simply.miniHeight(item_desc,item_desc_child);
    });
  }
};
simply.load = function(){

  var product_img_parent = "#related_product .grid-product__wrapper .img";
  var product_img_child = "#related_product .grid-product__wrapper .img img";

  var coll_img_parent = "#our_products .grid-uniform .img";
  var coll_img_child = "#our_products .grid-uniform .img .coll_img img";

  var new_package_page_img_parent = "#delicious-office-packages .item-image-wrapper .left_img_section .img"
  var new_package_page_img_child = "#delicious-office-packages .item-image-wrapper .left_img_section .img img"

  var new_package_page_product_content_parent = "#delicious-office-packages .right_img_section .coffee_packges_contents .add_product_content"
  var new_package_page_product_content_child = "#delicious-office-packages .right_img_section .coffee_packges_contents .add_product_content"

  var singles_img = ".eif-products .img.height-content";
  var singles_img_title = ".eif-products .eif-prod-title";

  var cold_brew_steps_title = ".coldbrew-steps .steps-data .cold-step .step-title";

  var our_prod_par = "#our_products .our_product_wrap .desc_wrap";
  var our_prod_child = "#our_products .left_box .our_product_wrap .desc_wrap .desc";
  var can_block_title = "#ground-cans .brew-selection .brew-title";
  var can_block_title_child = "#ground-cans .brew-selection .brew-title span";
  var can_block_desc_par = "#ground-cans .brew-selection .brew-desc";
  var can_block_desc_child = "#ground-cans .brew-selection .brew-desc .desc-text";
  $(window).on('load', function(e){
    if (simply.current_width >767){
      simply.miniHeight(product_img_parent,product_img_child);
      simply.miniHeight(coll_img_parent,coll_img_child);
      simply.miniHeight(new_package_page_img_parent,new_package_page_img_child);
      simply.miniHeight(new_package_page_product_content_parent,new_package_page_product_content_child);
      simply.miniHeight(cold_brew_steps_title,cold_brew_steps_title);
      simply.miniHeight(singles_img,singles_img);
      simply.miniHeight(singles_img_title,singles_img_title);
      simply.miniHeight(our_prod_par,our_prod_child);
      simply.miniHeight(can_block_title,can_block_title_child);
      simply.miniHeight(can_block_desc_par,can_block_desc_child); 
    }
    simply.collectionProdHeight();
  });
  $(window).resize(function(){//window resize
    simply.imageLoadOnScroll();
    simply.collectionProdHeight();
    if (simply.current_width >767){
      simply.miniHeight(product_img_parent,product_img_child);
      simply.miniHeight(coll_img_parent,coll_img_child);
      simply.miniHeight(new_package_page_img_parent,new_package_page_img_child);
      simply.miniHeight(new_package_page_product_content_parent,new_package_page_product_content_child);
      simply.miniHeight(cold_brew_steps_title,cold_brew_steps_title);
      simply.miniHeight(our_prod_par,our_prod_child);
      simply.miniHeight(can_block_title,can_block_title_child);
      simply.miniHeight(can_block_desc_par,can_block_desc_child);
    }
  });
};
$(document).ready(function(){
  simply.current_width = $(window).width();
  simply.init();
  simply.load();
});